/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { TransactionSummaryReportViewModel } from './TransactionSummaryReportViewModel';
import {
    TransactionSummaryReportViewModelFromJSON,
    TransactionSummaryReportViewModelFromJSONTyped,
    TransactionSummaryReportViewModelToJSON,
} from './TransactionSummaryReportViewModel';

/**
 * 
 * @export
 * @interface ResultOfTransactionSummaryReportViewModel
 */
export interface ResultOfTransactionSummaryReportViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {TransactionSummaryReportViewModel}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    data?: TransactionSummaryReportViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionSummaryReportViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfTransactionSummaryReportViewModel interface.
 */
export function instanceOfResultOfTransactionSummaryReportViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfTransactionSummaryReportViewModelFromJSON(json: any): ResultOfTransactionSummaryReportViewModel {
    return ResultOfTransactionSummaryReportViewModelFromJSONTyped(json, false);
}

export function ResultOfTransactionSummaryReportViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTransactionSummaryReportViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : TransactionSummaryReportViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfTransactionSummaryReportViewModelToJSON(value?: ResultOfTransactionSummaryReportViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': TransactionSummaryReportViewModelToJSON(value.data),
        'Count': value.count,
    };
}

